import * as utils from './utils'
import * as scroll from './scroll'
import * as typeOf from './typeof'
import * as lzString from './lzString'
import * as track from './track'
import * as optionImageSize from './optionImageSize'
import * as pcJumpUrl from '../js/pcJumpUrl'

export default {
  ...utils,             // 工具类
  ...scroll,            // 滚动条类
  ...typeOf,            // 判断类型
  ...lzString,          // 压缩字符串
  ...track,             // 埋点方法
  ...optionImageSize,    // 选项图片尺寸
  ...pcJumpUrl          // PC 端 hash 跳转（国内 /bloom_web，海外根路径与域名替换）
}



// WEBPACK FOOTER //
// ./src/assets/utils/index.js